import { render, staticRenderFns } from "./UpdateUserPage.vue?vue&type=template&id=449b93c4"
import script from "./UpdateUserPage.vue?vue&type=script&lang=js"
export * from "./UpdateUserPage.vue?vue&type=script&lang=js"
import style0 from "./UpdateUserPage.vue?vue&type=style&index=0&id=449b93c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports